import { parseAsStringEnum, useQueryState } from "nuqs";
import { MainPageTabs } from "@/pages/restricted/shared/main-page/model/types";
import { useSessionStore } from "@/entities/session";
import { Roles } from "@/entities/user";

export function useIsCurrentlyAtDashboardPro(roles: Roles[]) {
  const [tab] = useQueryState(
    "tab",
    parseAsStringEnum<MainPageTabs>(Object.values(MainPageTabs)).withDefault(
      MainPageTabs.DASHBOARD,
    ),
  );

  const { user } = useSessionStore();

  return tab === MainPageTabs.DASHBOARD_PRO && roles.includes(user?.role!);
}
